import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
// [R32] China/WeChat reachability: fonts + icons are SELF-HOSTED (bundled,
// served from our own domain). Google Fonts is hard-blocked in mainland China
// and jsdelivr is unreliable there — a client in WeChat would get no brand
// fonts and empty icon boxes. Weights mirror the old fonts.googleapis.com
// css2 request exactly (Playfair 400-800, Montserrat 300-700, Pacifico 400).
import '@fontsource/playfair-display/400.css'
import '@fontsource/playfair-display/500.css'
import '@fontsource/playfair-display/600.css'
import '@fontsource/playfair-display/700.css'
import '@fontsource/playfair-display/800.css'
import '@fontsource/montserrat/300.css'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'
import '@fontsource/pacifico/400.css'
import 'remixicon/fonts/remixicon.css'
import './index.css'
import App from './App.tsx'
// [T175] WebMCP progressive enhancement: register the read capability tools if
// the browser exposes navigator.modelContext. Feature-detected no-op elsewhere
// (never throws) — in-browser agents call the SAME agent-api REST route.
import { registerAgentWebMCP } from './agent/webmcp.ts'
// [T239] First-party telemetry: global error reporting + a six-stage funnel, all
// of it ours. No third-party script, no cookie, no cross-session identifier. It
// silences itself entirely on DNT, on GPC, and on VITE_PUBLIC_TELEMETRY=off, and
// it never throws — see src/lib/telemetry.ts for the four silences and what a
// row may contain at all.
import { initTelemetry } from './lib/telemetry.ts'

registerAgentWebMCP()
initTelemetry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
